var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};


site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

site.spjallmenni = site.spjallmenni || {};
site.spjallmenni = {
	init: function () {
		$(document).ready(function () {
			const triggerContainer = document.getElementById('triggerContainer');
			const triggerTextButton = document.getElementById('triggerTextButton');
			const triggerText = document.getElementById('triggerText');
			const triggerImageButton = document.getElementById('triggerImageButton');
			const closeButton = document.getElementById('closeButton');
			const hasInteractedThisSession = sessionStorage.getItem('hasInteractedThisSession');

			// Determine the language based on the URL
			var path = window.location.pathname;
			var browser_language = (path === '/en' || path.startsWith('/en/')) ? 'English' : 'Icelandic';

			// Set the trigger text based on the language
			if (browser_language === 'English') {
				triggerText.innerHTML = "Hello, my name is Sigrún, your AI concierge at Sjúkraþjálfun Íslands.<br><br>How may I help you today?";
			} else {
				triggerText.innerHTML = "Halló, ég heiti Sigrún, gervigreindar þjónustufulltrúi Sjúkraþjálfun Íslands.<br><br>Hvernig get ég aðstoðað þig?";
			}

			if (!hasInteractedThisSession) {
				setTimeout(() => {
					triggerContainer.style.opacity = '1';
					triggerContainer.style.transform = 'translate(0, 0)';
					triggerContainer.style.pointerEvents = 'auto';
				}, 1000);
			}

			const loadSpjallmenniWidget = () => {
				window.VG_CONFIG = {
					ID: "l1hkim5bkrdlbv06",
					region: 'eu',
					render: 'bottom-right',
					variables: {
						autoStartWidget: false,
						browser_language: browser_language
					},
					stylesheets: [
						" https://spjallmenni-is.github.io/bot-scripts/assets/vg_dev_build/styles.css",
					],
					onLoad: function() {
						if (window.VG_CHAT && typeof window.VG_CHAT.open === 'function') {
							window.VG_CHAT.open();
						}
					}
				};

				const VG_SCRIPT = document.createElement("script");
				VG_SCRIPT.src = " https://spjallmenni-is.github.io/bot-scripts/assets/vg_dev_build/vg_bundle.js";
				VG_SCRIPT.defer = true;
				document.body.appendChild(VG_SCRIPT);
				VG_SCRIPT.id = 'spjallmenni-web-runtime';
				triggerContainer.style.display = 'none';
				triggerImageButton.style.display = 'none';
				sessionStorage.setItem('hasInteractedThisSession', 'true');
			};

			triggerTextButton.addEventListener('click', loadSpjallmenniWidget);
			triggerImageButton.addEventListener('click', loadSpjallmenniWidget);

			closeButton.addEventListener('click', (event) => {
				event.stopPropagation();
				triggerContainer.style.display = 'none';
				triggerContainer.style.pointerEvents = 'none';
				sessionStorage.setItem('hasInteractedThisSession', 'true');
			});
		});

		function waitForElmID(eleID) {
			return new Promise(resolve => {
				const element = document.getElementById(eleID);
				if (element) {
					resolve(element);
				} else {
					const observer = new MutationObserver((mutations, observer) => {
						const element = document.getElementById(eleID);
						if (element) {
							observer.disconnect();
							resolve(element);
						}
					});
					observer.observe(document.body, {
						childList: true,
						subtree: true
					});
				}
			});
		}

		waitForElmID('vg_chat_toggle').then(ele => ele.click());
	},
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	//site.svg.init();
	site.spjallmenni.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
